import { Providers } from "@/app/providers";
import { Routes } from "@/app/routes";

export function App() {
  return (
    <Providers>
      <Routes />
    </Providers>
  );
}
